import { jsxs, jsx } from 'react/jsx-runtime';
import classnames from 'classnames';
import cn from 'classnames/bind';
import ownClasses from './index.module.scss.js';

const boundClasses = cn.bind(ownClasses);
const sizeToTextSizeMap = {
    small: 'small',
    medium: 'normal',
    large: 'normal',
};
const ButtonLink = ({ href, design = 'solid', size = 'medium', children, rel, target, onClick, classes = [], icon, iconLeft, iconRight, }) => {
    const leftIcon = iconLeft || icon;
    const rightIcon = iconRight;
    return (jsxs("a", { href: href, rel: rel, className: classnames(boundClasses('link', design, size), ...classes), target: target, onClick: onClick, children: [leftIcon, jsx("span", { className: classnames('button-text', sizeToTextSizeMap[size], boundClasses('button-text')), children: children }), rightIcon] }));
};
ButtonLink.displayName = 'ButtonLink';

export { ButtonLink };
//# sourceMappingURL=index.js.map
